import React, { Component } from "react";
import KickImage from 'Reuseables/KickImage';
import { connect } from "react-redux";
import { Row, Col, Container } from "reactstrap";
import { Link } from "react-router-dom";
import PromoBannerBank from "./kickAvenueFair/PromoBannerBank";
import {
  StealDeals,
  SpecialDeals,
  LocalBrandsSection,
  OfficialMerchandise,
  RaffleNovembazar,
  TradingPit,
  ExclusiveLaunch,
  SurpriseDrop,
  MadeInIndonesia,
  CategorySection,
  UnderRetail,
} from "./kickAvenueFair";
import {
  getRaffleGroup,
  getUserRaffleTickets,
  getCollectionBrands,
} from "../../actions/kafairAction";
import BackgroundLuxury from "../../images/kafairbackground-1.svg";
import BackgroundStreetwear from "../../images/kafairbackground-2.svg";
import BackgroundLifeStyle from "../../images/kafairbackground.svg";
import BackgroundMerchandise from "../../images/plain-green.jpg";
import BackgroundMadeInIndoensia from "../../images/kafair-indonesia.jpg";

// Header
import HeaderCategoryLifestyles from "../../images/harbolkick-category-lifestyles.png";
import HeaderCategoryStreetwear from "../../images/harbolkick-category-streetwear.png";
import HeaderCategoryLuxury from "../../images/harbolkick-category-luxury.png";
import HeaderCategorySneakers from "../../images/harbolkick-category-sneakers.png";
import HeaderCategoryIndonesia from "../../images/harbolkick-category-indonesia.png";
import HeaderCategoryMerchandise from "../../images/harbolkick-category-merchandise.png";

// Raffle Holiday
import HolidayBackground from "../../images/holiday-background-harbolnas.png";
import HolidayHeader from "../../images/holiday-header-harbolnas.png";

// RaffleGoodDay
import GoodDayHeader from "../../images/good-day-header-harbolnas.png";
import GoodDayBackground from "../../images/good-day-background-harbolnas.png";

class NovembazarContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      categoryList: [
        {
          title: "Sneakers",
          category: "sneakers",
          icon: require("../../images/sneakers.png"),
          slug: "sneakers-bcaxkickavenue",
          name: "sneakers_harbolnas",
          background: "#24553E",
          header: HeaderCategorySneakers,
        },
        {
          title: "Apparel",
          category: "apparels",
          icon: require("../../images/streetwear.png"),
          slug: "streetwear-bcaxkickavenue",
          name: "streetwear_harbolnas",
          background: "#9B2520",
          header: HeaderCategoryStreetwear,
        },
        {
          title: "Luxury",
          category: "handbags",
          icon: require("../../images/luxury.png"),
          slug: "luxury-bcaxkickavenue",
          name: "luxury_harbolnas",
          background: "#FCFBEE",
          header: HeaderCategoryLuxury,
        },
        {
          title: "Electronics & Collectibles",
          category: "lifestyles",
          icon: require("../../images/lifestyle.png"),
          slug: "lifestyle-bcaxkickavenue",
          name: "lifestyle_harbolnas",
          background: "#FFDF37",
          header: HeaderCategoryLifestyles,
        },
        {
          title: "Made In Indonesia",
          category: "local_brands",
          icon: require("../../images/lifestyle.png"),
          slug: "local-brands",
          name: "local_brands",
          background: "linear-gradient(to bottom, #CE1126 50%, white 50%)",
          header: HeaderCategoryIndonesia,
        },
      ],
    };
  }

  componentDidMount() {
    this.props.getRaffleGroup();
    this.props.getUserRaffleTickets();
    getCollectionBrands(
      {
        page: 1,
        per_page: 30,
      },
      "local-brands"
    );
  }

  RefCategory = (slug) => {
    switch (slug) {
      case "sneakers-bcaxkickavenue":
        return this.props.sneakersSectionRef;
      case "streetwear-bcaxkickavenue":
        return this.props.apparelsSectionRef;
      case "luxury-bcaxkickavenue":
        return this.props.handbagsSectionRef;
      case "lifestyle-bcaxkickavenue":
        return this.props.lifestylesSectionRef;

      default:
        return this.props.sneakersSectionRef;
    }
  };

  render() {
    const { raffle, raffleGroup, localBrands } = this.props;
    const { categoryList } = this.state;
    const raffles = raffleGroup
      ? raffleGroup.map((rg) => {
        return {
          ...raffle[rg.query],
          ticket_name: rg.ticket_name,
          ticket_type: rg.ticket_type,
          key: rg.key,
          title: rg.title,
          color: rg.color,
          children: rg.children,
        };
      })
      : [];

    return (
      <div>
        <div ref={this.props.BcaPromoRef}>

        </div>
        {raffles.length > 0 && raffles[0] && (
          <div ref={this.props.fairGroundRef} id="gold-raffle">
            <Container fluid className="special-deals-section">
              <RaffleNovembazar
                title={raffles[0].title}
                products={raffles[0].products}
                isGolden={raffles[0].golden}
                // background={GoodDayBackground}
                header={GoodDayHeader}
                start_date={raffles[0].start_date}
                expiry_date={raffles[0].expiry}
                // imageClass={"kafair-title-header"}
                ticket_name={raffles[0].ticket_name}
                title={raffles[0].title}
                color={raffles[0].color}
                group_name={raffles[0].group_name}
                key={raffles[0].key}
                ticket_type={raffles[0].ticket_type}
                // description={raffles[0].description}
                description={"Raffle by Bank BCA"}
                history={this.props.history}
                containerColor={"#173485"}
                buttonColor={"rgba(255, 255, 255, 0.4)"}
                titleColor={"#FFF"}
                buttonTitleColor={"#0a2a5c"}
                children={
                  (raffles[0].children.length > 0 && raffles[1].children[1]) ||
                  null
                }
                isNovembazar
                noBorder
                noTimer
              />
            </Container>
          </div>
        )}

        <div ref={this.props.UnderRetailRef}>
          <UnderRetail
            backgroundColor="#5b339b"
            title="Under Retail"
            slug="under-retail-bca-launch"
            name="under_retail"
            classname="under-retail-wrapper"
          />
        </div>
        <div ref={this.props.indonesianBrandsRef}>
          <CategorySection
            title={categoryList[4].title}
            name={categoryList[4].name}
            category={categoryList[4].category}
            icon={categoryList[4].icon}
            slug={categoryList[4].slug}
            history={this.props.history}
            background={categoryList[4].background}
            header={categoryList[4].header}
          />
        </div>
        <div>
          <PromoBannerBank />
        </div>
        <div ref={this.props.MerchandiseRef}>
          <UnderRetail
            backgroundColor="#159953"
            title="Official Merchandise"
            slug="official-merchandise"
            name="merchandise"
            classname="merchandise-outer-wrapper"
          />
        </div>

        {/* {categoryList.map((item) => (
          <div ref={this.RefCategory(item.slug)}>
            <CategorySection
              title={"Made In Indonesia"}
              name={item.name}
              category={item.category}
              icon={item.icon}
              slug={item.slug}
              history={this.props.history}
              background={item.background}
              header={item.header}
            />
          </div>
        ))}
        <div ref={this.props.indonesianBrandsRef}>
          <MadeInIndonesia
            history={this.props.history}
            background={BackgroundMadeInIndoensia}
            header={HeaderCategoryIndonesia}
          />
        </div> */}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  raffle: state.dataKaFair.raffle,
  raffleGroup: state.dataKaFair.raffleGroup.data,
  localBrands: state.dataKaFair.local_brands,
});

const mapDispatchToProps = (dispatch) => ({
  getUserRaffleTickets: () => dispatch(getUserRaffleTickets()),
  getRaffleGroup: () => dispatch(getRaffleGroup()),
  getCollectionBrands: (payload, slug) =>
    dispatch(getCollectionBrands(payload, slug)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NovembazarContainer);
